import React from 'react';
import { ArtworkDetailsModal } from 'iovisit-museum-theme/components';

const SliderPreviewImageMore = ({ item }) => {
  return item['@type'] === 'Artwork' ? (
    <ArtworkDetailsModal artwork={item} />
  ) : (
    <></>
  );
};

export default SliderPreviewImageMore;
